module.exports = __webpack_public_path__ + "img/zhifubao_icon_xzczfs.5df07d1d.png";